import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../app/store";
interface USER {
  uid: string;
  displayName: string;
  employeeNo: string;
  employeeName: string;
  jobCategory: string;
  jobCategoryCodeOA: string;
  departmentCodeOA: string;
  departmentNameOA: string;
  hqDepartmentCodeOA: string;
  hqDepartmentNameOA: string;
  mailAddress: string;
  // 担当ZONEコード
  zoCode: string[];
  // 担当DOコード
  doCode: string[];
  deviceType: Boolean;
  ios: Boolean;
  iphone: Boolean;
  tenpoCode: string[];
  // GoogleCloudStorageの画像アクセス用のトークン
  imageToken: string;
  notification: {};
  ofcId: string;
  userAuth: string;
}

export const userSlice = createSlice({
  name: "user",
  initialState: {
    user: {
      uid: "",
      displayName: "",
      employeeNo: "",
      employeeName: "",
      jobCategory: "",
      jobCategoryCodeOA: "",
      departmentCodeOA: "",
      departmentNameOA: "",
      hqDepartmentCodeOA: "",
      hqDepartmentNameOA: "",
      mailAddress: "",
      zoCode: [],
      zoValue: [],
      doCode: [],
      doValue: [],
      deviceType: false,
      ios: false,
      iphone: false,
      tenpoCode: [],
      tenpoValue: [],
      imageToken: "",
      notification: { flag: false, title: "", text: "", term: "" },
      ofcId: "",
      userAuth: "",
    },
  },
  reducers: {
    login: (state, action) => {
      state.user = action.payload;
    },
    logout: (state) => {
      state.user = {
        uid: "",
        displayName: "",
        employeeNo: "",
        employeeName: "",
        jobCategory: "",
        jobCategoryCodeOA: "",
        departmentCodeOA: "",
        departmentNameOA: "",
        hqDepartmentCodeOA: "",
        hqDepartmentNameOA: "",
        mailAddress: "",
        zoCode: [],
        zoValue: [],
        doCode: [],
        doValue: [],
        deviceType: false,
        ios: false,
        iphone: false,
        tenpoCode: [],
        tenpoValue: [],
        imageToken: "",
        notification: { flag: false, title: "", text: "", term: "" },
        ofcId: "",
        userAuth: "",
      };
    },
    setUserAuth: (state, action) => {
      state.user.userAuth = action.payload;
    },
    updateUserProfile: (state, action: PayloadAction<USER>) => {
      state.user.uid = action.payload.uid;
      state.user.displayName = action.payload.displayName;
    },
    setIsDeviceType: (state, action) => {
      state.user.deviceType = action.payload.deviceType;
      state.user.ios = action.payload.ios;
      state.user.iphone = action.payload.iphone;
    },
    updateImageToken: (state, action) => {
      if (
        action.payload.imageToken === undefined ||
        action.payload.imageToken === ""
      ) {
        // 空であれば更新しない
        return;
      }
      state.user.imageToken = action.payload.imageToken;
    },
    updateNotification: (state, action) => {
      state.user.notification = action.payload.notification;
    },
  },
});

export const {
  login,
  logout,
  setUserAuth,
  updateUserProfile,
  setIsDeviceType,
  updateImageToken,
  updateNotification,
} = userSlice.actions;
export const selectUser = (state: RootState) => state.user.user;
export const selectIsDeviceType = (state: RootState) =>
  state.user.user.deviceType;
export const selectIsIos = (state: RootState) => state.user.user.ios;
export const selectIsIphone = (state: RootState) => state.user.user.iphone;
export const selectImageToken = (state: RootState) => {
  return state.user.user.imageToken;
};
export const selectNotification = (state: RootState) =>
  state.user.user.notification;
export default userSlice.reducer;
